module.exports = __webpack_public_path__ + "img/2.e5da84c9.jpg";